import { ActionIcon, Badge, Indicator, Tooltip } from '@mantine/core';
import { IconClockShare } from '@tabler/icons-react';
import { useMediaQuery } from '@mantine/hooks';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api, TIME_PROPOSAL_COUNT_QUERY_KEY } from '../lib/api';

/**
 * Kopfzeile: Zeitvorschläge, die auf meine Freigabe warten (v1.404.0). Nichts anzeigen, wenn nichts
 * wartet — eine Dauer-„0" fiele nach zwei Wochen niemandem mehr auf.
 */
export function TimeProposalIndicator() {
  const isMobile = useMediaQuery('(max-width: 48em)');
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: TIME_PROPOSAL_COUNT_QUERY_KEY,
    queryFn: () => api.getTimeProposalCount(),
    refetchInterval: 60_000,
  });
  const n = data?.received ?? 0;
  if (n === 0) return null;
  const label = `${n} ${n === 1 ? 'Zeitvorschlag wartet' : 'Zeitvorschläge warten'} auf deine Freigabe`;
  const open = () => navigate('/zeitvorschlaege');

  return (
    <Tooltip label={label} withArrow>
      {isMobile ? (
        <ActionIcon variant="light" color="grape" aria-label={label} onClick={open}>
          <Indicator label={n} size={14} color="grape">
            <IconClockShare size={16} />
          </Indicator>
        </ActionIcon>
      ) : (
        <Badge color="grape" variant="light" leftSection={<IconClockShare size={12} />} style={{ cursor: 'pointer' }} onClick={open}>
          {n} {n === 1 ? 'Zeitvorschlag' : 'Zeitvorschläge'}
        </Badge>
      )}
    </Tooltip>
  );
}
